import React from 'react';

import type { RemixHiddenOptionsResolverProps } from '../../malleableUiPluginType';

export const EmptyRemixHiddenOptionsResolver = ({
	children,
}: RemixHiddenOptionsResolverProps): React.ReactNode => children([]);
